import * as actionTypes from './actionTypes';

const initionState = {
  pdpHistory: [],
  backButtonHistory: 0,
};

export default function pdpHistoryReducer(state = initionState, action = {}) {
  switch (action.type) {
    case actionTypes.INCREASE_PDP_HISTORY: {
      return {
        ...state,
        pdpHistory: [...state.pdpHistory, action.payload],
      };
    }
    case actionTypes.DECREASE_PDP_HISTORY: {
      const newPdpHistory = state.pdpHistory.filter((contentId) => contentId !== action.payload);
      return {
        ...state,
        pdpHistory: newPdpHistory,
      };
    }
    case actionTypes.RESET_PDP_HISTORY: {
      return {
        ...state,
        pdpHistory: [],
      };
    }
    case actionTypes.INCREASE_BACK_BUTTON_HISTORY: {
      return {
        ...state,
        backButtonHistory: state.backButtonHistory + 1,
      };
    }
    case actionTypes.RESET_BACK_BUTTON_HISTORY: {
      return {
        ...state,
        backButtonHistory: 0,
      };
    }
    default: {
      return state;
    }
  }
}
